// extracted by mini-css-extract-plugin
export default {"shopName":"shop-list_shopName__3eQUr","fieldGroup":"shop-list_fieldGroup__SBqi1","lmCard":"shop-list_lmCard__2HoNu","termsAndCondTxt":"shop-list_termsAndCondTxt__KS7T9"};